// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type QuestionMarkCircle48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const QuestionMarkCircle48Filled: FC<QuestionMarkCircle48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M24.2 35.65c.533 0 .983-.183 1.35-.55.367-.367.55-.817.55-1.35 0-.533-.183-.983-.55-1.35a1.835 1.835 0 0 0-1.35-.55c-.533 0-.983.183-1.35.55-.367.367-.55.817-.55 1.35 0 .533.183.983.55 1.35.367.367.817.55 1.35.55Zm-1.75-7.3h2.95c0-.867.108-1.658.325-2.375.217-.717.892-1.542 2.025-2.475 1.033-.867 1.767-1.717 2.2-2.55.433-.833.65-1.75.65-2.75 0-1.767-.575-3.183-1.725-4.25-1.15-1.067-2.675-1.6-4.575-1.6-1.633 0-3.075.408-4.325 1.225-1.25.817-2.158 1.942-2.725 3.375l2.65 1c.367-.933.917-1.658 1.65-2.175.733-.517 1.6-.775 2.6-.775 1.133 0 2.05.308 2.75.925.7.617 1.05 1.408 1.05 2.375 0 .733-.217 1.425-.65 2.075-.433.65-1.067 1.325-1.9 2.025-1 .867-1.742 1.725-2.225 2.575-.483.85-.725 1.975-.725 3.375ZM24 44c-2.733 0-5.317-.525-7.75-1.575-2.433-1.05-4.558-2.483-6.375-4.3-1.817-1.817-3.25-3.942-4.3-6.375C4.525 29.317 4 26.733 4 24c0-2.767.525-5.367 1.575-7.8 1.05-2.433 2.483-4.55 4.3-6.35 1.817-1.8 3.942-3.225 6.375-4.275C18.683 4.525 21.267 4 24 4c2.767 0 5.367.525 7.8 1.575 2.433 1.05 4.55 2.475 6.35 4.275 1.8 1.8 3.225 3.917 4.275 6.35C43.475 18.633 44 21.233 44 24c0 2.733-.525 5.317-1.575 7.75-1.05 2.433-2.475 4.558-4.275 6.375-1.8 1.817-3.917 3.25-6.35 4.3C29.367 43.475 26.767 44 24 44Z" />
        </svg>
    );
};

export default QuestionMarkCircle48Filled;
